module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v("Cast of Characters")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RNESTINE")]), _vm._v("—hates men and vents her spite in a way that’s sure to lead to trouble")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REDDY")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IXON")]), _vm._v("—who pays dearly for his sordid past")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS")]), _vm._v(". L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACOSTE")]), _vm._v("—matriarchal goof-ball lover who indulges herself when her family is out of the way")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(". P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENNYFEATHER")]), _vm._v("—an ardent, if absent-minded, devotee of Milton and mysteries")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARADYNE")]), _vm._v("—worries about her cousin, Ernestine’s, escapades")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS")]), _vm._v(". M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUFFIT")]), _vm._v("—whose cooking comforts Mr. Pennyfeather but fails to fatten him")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROFESSOR")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ODT")]), _vm._v("—cultivates beans and looks for the psychological causes of plant and human behavior")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(". S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TEPHEN")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNNE")]), _vm._v("—red-bearded beach-combing artist, devoted to drink and driftwood, and his nieces, Ernestine and Rae")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("APTAIN")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LNEY")]), _vm._v("—doesn’t say much, but there’s no wool over his eyes")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS")]), _vm._v(". L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAND")]), _vm._v("—wife of a college professor, distracted by dogs and bawling babies")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORETTA")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULLENS")]), _vm._v("—ex-pupil of Mr. Pennyfeather’s, is surprised to find herself mixed up in murder")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(". J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AROLD")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CTON")]), _vm._v("—one-time schoolteacher who used his position to lead youth astray")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RS")]), _vm._v(". C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ULLENS")]), _vm._v("—Loretta’s mother, clubwoman walking a tight rope")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63cbe7f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Characters.vue
// module id = 72
// module chunks = 0